import React from "react";
import "animate.css";
import { useInView } from "react-intersection-observer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faFax, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import contactBackground from "../../assets/contact.png";
import GoogleMap from "./GoogleMap";

const locations = [
  {
    id: "toronto",
    locationName: "Toronto",
    mapQuery: "AMR+LLP+145+Wellington+Street+West,+Toronto,+ON+M5J+1H8",
    mapTitle: "Google Map of Toronto Office",
    addressLines: [
      "300 - 145 Wellington Street West",
      "Toronto, Ontario",
      "M5J 1H8",
    ],
    contact: {
      phone: "4163699393",
      phoneDisplay: "416-369-9393",
      fax: "4163690665",
      faxDisplay: "416-369-0665",
      email: "info@amrlaw.ca",
    },
  },
  {
    id: "ottawa",
    locationName: "Ottawa",
    mapQuery: "1338+Wellington+Street+West,+Unit+10,+Ottawa,+ON+K1Y+3B7",
    mapTitle: "Google Map of Ottawa Office",
    addressLines: [
      "1338 Wellington Street West, Unit 10",
      "Ottawa, Ontario",
      "K1Y 3B7",
    ],
    contact: null,
  },
];

const Contact = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <article
      id="contact"
      style={{
        backgroundImage: `url(${contactBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className={`contact-content ${
          inView ? "animate__animated animate__fadeIn" : ""
        }`}
        style={{ visibility: inView ? "visible" : "hidden" }}
        ref={ref}
      >
        <h1 className="section-h1">Contact Us</h1>

        {locations.map((location) => (
          <div className="location-row" key={location.id}>
            <div className="map-container">
              <GoogleMap query={location.mapQuery} title={location.mapTitle} />
            </div>
            <div className="contact-copy">
              <div>
                <h2 className="section-h1 location-name">
                  {location.locationName}
                </h2>

                {location.addressLines.map((line, i) => (
                  <p className="contact-para" key={i}>
                    {line}
                  </p>
                ))}

                {location.contact && (
                  <div className="social-links">
                    <a href={`tel:${location.contact.phone}`} className="contact-link">
                      <FontAwesomeIcon
                        aria-label="phone icon"
                        icon={faPhone}
                        title="phone"
                        className="nav-icon"
                      />
                      {location.contact.phoneDisplay}
                    </a>
                    <a href={`fax:${location.contact.fax}`} className="contact-link">
                      <FontAwesomeIcon
                        aria-label="fax icon"
                        icon={faFax}
                        title="fax"
                        className="nav-icon"
                      />
                      {location.contact.faxDisplay}
                    </a>
                    <a href={`mailto:${location.contact.email}`} className="contact-link">
                      <FontAwesomeIcon
                        aria-label="email icon"
                        icon={faEnvelope}
                        title="email"
                        className="nav-icon"
                      />
                      {location.contact.email}
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </article>
  );
};

export default Contact;
